const langDocumentAccessTable = {
	document_name: {
		tag: 'document.access.table.document_name',
		fr: 'Nom du document',
		en: 'Document name',
	},
	document_type: {
		tag: 'document.access.table.document_type',
		fr: 'Type de document',
		en: 'Document type',
	},
	group: {
		tag: 'document.access.table.group',
		fr: 'Groupe',
		en: 'Group',
	},
	fund_type: {
		tag: 'document.access.table.fund_type',
		fr: 'Type de fonds',
		en: 'Funds type',
	},
	access_time: {
		tag: 'document.access.table.access_time',
		fr: 'Date de téléchargement',
		en: 'Download access time',
	},
	release_date: {
		tag: 'document.access.table.release_date',
		fr: 'Date de sortie',
		en: 'Release date',
	},
	isImpersonated: {
		tag: 'document.access.table.isImpersonated',
		fr: 'Imité',
		en: 'Impersonated',
	},
	download: {
		tag: 'document.access.table.download',
		fr: 'Télécharger',
		en: 'Download',
	},
	view: {
		tag: 'document.access.table.view',
		fr: 'Détail',
		en: 'Detail',
	},
	fund: {
		tag: 'document.access.table.fund',
		fr: 'Nom du fonds',
		en: 'Fund name',
	},
	expertise: {
		tag: 'document.access.table.expertise',
		fr: 'Expertise',
		en: 'Expertise',
	},
};

export default langDocumentAccessTable;
